import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import SharedIntlProviderHOC from "../hocs/sharedIntlProviderHOC";

/*
* flow:
* 1) fire ajax call to send
* 2) render page
* 3) submit info
* 4) move flow forward correctly (signup, transactable, profile)
*   - use this.props.onSuccessfulSubmit
*
* Dependent Props for display:
  - user
  - componentWillMountAction
  - updateAction

  Callback Props:
  - finalCallback
  - finalCBArg
 */

class VerifyEmail extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      sentCodeToUser: false,
      errorMessage: ""
    }

    this.prepData = this.prepData.bind(this);
    this.sendVerification = this.sendVerification.bind(this);
    this.onEmailCodeReturn = this.onEmailCodeReturn.bind(this);
    this.prepData = this.prepData.bind(this);
    this.onSubmitVerificationCode = this.onSubmitVerificationCode.bind(this);
  }

  componentWillMount () {
    //add ajax call to start then render form
    const sendCodeToUserEmail = this.props.componentWillMountAction;
    sendCodeToUserEmail(this.onEmailCodeReturn);
  }

  prepData (event) {
    event.preventDefault();
    const input = document.getElementById("email-verify");
    const inputValue = input.value;
    if (4 > inputValue.length) {
      const errorMsg = this.props.intl.formatMessage({ id: 'shared_components.verify_email.add_valid_code', defaultMessage: 'Please add a valid code' });
      return this.setState({errorMessage: errorMsg});
    } else {
      const payload = {email_verification_code: inputValue};
      const updateAction = this.props.updateAction;
      const payloadStr = JSON.stringify(payload);
      return updateAction(payloadStr, this.onSubmitVerificationCode);
    }
  }

  onSubmitVerificationCode (data, textStatus, jqHXR) {
    if ("success" === textStatus) {
      return this.props.callback(data, textStatus, true);
    } else {
      const errorMsg = data.responseJSON.error;
      this.setState({errorMessage: errorMsg});
    }
  }
  onEmailCodeReturn (response, textStatus, jqXHR) {
    // this.state.sentCodeToUser => true;
    const emailSent = "success" === textStatus

    this.setState({sentCodeToUser: emailSent});
  }

  sendVerification (event) {
    event.preventDefault();
    const sendCodeToUserEmail = this.props.componentWillMountAction;
    sendCodeToUserEmail(this.onEmailCodeReturn);
    analyticsIntegrations.resendVerification();
  }

  render () {
    // data needs: user email, user ssoid, user first name
    const helperEmailText = this.props.intl.formatMessage({ id: 'shared_components.verify_email.help_peerspace', defaultMessage: 'Hi Peerspace, can you help me verify my email address. My user ID is {ssoId}. Thanks! {firstName}' }, { ssoId: this.props.user.SSOid, firstName: this.props.user.first_name });
    let inputClass = "col-xs-8";
    if (this.state.errorMessage) {
      inputClass = "col-xs-8 input-error";
    }
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <div id="verify-email" className="col-xs-12">
        <h3 className="text-center">
          <FormattedMessage
            id='shared_components.verify_email.verify_email'
            defaultMessage='Verify Your Email'
          />
        </h3>
        <form id="email-verify-form">
          <p className="text-center">
            <FormattedMessage
              id='shared_components.verify_email.check_email'
              defaultMessage='Please check your email and enter the 4-digit code below to make sure your account is valid.'
            />
          </p>
          <div className="col-xs-6 col-xs-offset-3 flex middle">
            <input id="email-verify" className={inputClass} type="text" maxLength="4" placeholder="XXXX"/>
            <button className="col-xs-4 btn btn-primary classic margin-md-left" onClick={this.prepData}>
              <FormattedMessage
                id='shared_components.verify_email.check_email_button'
                defaultMessage='Verify'
              />
            </button>
          </div>
          <p className="text-danger col-xs-6 col-xs-offset-3">{this.state.errorMessage}</p>
        </form>
        <p className="col-xs-12 text-center">
          <FormattedMessage
            id='shared_components.verify_email.didnt_get_email'
            defaultMessage='Didn’t get an email? It can take a few minutes, but also check your Spam and Promotions folder.'
          />
        </p>
        <p className="col-xs-12 text-center">
          <span id="resend-email-code" onClick={this.sendVerification}>
            <span className="underline">
              <FormattedMessage
                id='shared_components.verify_email.resend_code'
                defaultMessage='Resend code'
              />
            </span>
          </span>
          <span>&nbsp;
            <FormattedMessage
              id='shared_components.verify_email.contact_us'
              defaultMessage='or contact our support team'
            />&nbsp;
          </span>
          <a className="underline" target="_blank" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>here</a>
        </p>
      </div>
    );
  }
}

module.exports = injectIntl(VerifyEmail);
